import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import { useJspVariables, useNavigation, useAppContext, useDebugRender } from '../hooks';
import { ExpandMoreIcon, PageContainer, PageHeader } from '../components';

const PageTfaHelp = () => {
    useDebugRender('PageTfaHelp');
    const { jspVariables, panelStyle } = useJspVariables();
    const { toPageLogin, toPageEmailPasscode, toPageTfaRegister } = useNavigation();
    const { getLabelFromJspVariables } = useAppContext(jspVariables);

    return (
        <PageContainer id="pageTfaHelp" dataAutomationId="page_tfa_help" sx={panelStyle}>
            <Box>
                <Grid xs={12} display="flex" justifyContent="flex-end">
                    <Button variant="text" onClick={toPageLogin}
                        data-automation-id="tfa_help_back_btn">
                        {getLabelFromJspVariables('action_page_back')}
                    </Button>
                </Grid>
                <PageHeader dataAutomationId="tfa_help_header">{getLabelFromJspVariables('tfa_help_title')}</PageHeader>
            </Box>
            <Box>
                <Typography variant="h6" sx={{ pt: 1 }}>{getLabelFromJspVariables('being_prompted_otp')}</Typography>
                <Typography variant="body2">{getLabelFromJspVariables('check_your_email')}</Typography>

                <Typography variant="h6" sx={{ pt: 2 }}>{getLabelFromJspVariables('tfa_need_help')}</Typography>
                <Box component="ul" sx={{ listStyle: 'none', p: 0 }}>
                    <li>
                        <Link component="button" variant="body2" onClick={toPageEmailPasscode}
                            data-automation-id="tfa_help_email_passcode_link">
                            {getLabelFromJspVariables('forgot_device_receive')}
                        </Link>
                    </li>
                    <li>
                        <Link component="button" variant="body2" onClick={() => toPageTfaRegister(false)}
                            data-automation-id="tfa_help_tfa_register_link">
                            {getLabelFromJspVariables('update_tfa_lost')}
                        </Link>
                    </li>
                </Box>

                <Accordion sx={{ mt: 2 }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography fontWeight={600}>{getLabelFromJspVariables('code_not_working')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="body2">
                            {getLabelFromJspVariables('valid_3_minutes')}<br />
                            {getLabelFromJspVariables('enter_all_digits')}
                            {getLabelFromJspVariables('if_you_still_call')}
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography fontWeight={600}>{getLabelFromJspVariables('info_about_tfa')}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant="subtitle2" sx={{ mt: 1 }}>{getLabelFromJspVariables('what_is_tfa')}</Typography>
                        <Typography variant="body2">
                            {getLabelFromJspVariables('tfa_provides_unique')}
                            {getLabelFromJspVariables('tfa_asks_allow')}
                            {getLabelFromJspVariables('tfa_requires_email_or_device')}
                            {getLabelFromJspVariables('enter_code_from_device')}
                        </Typography>

                        <Typography variant="subtitle2" sx={{ mt: 2 }}>{getLabelFromJspVariables('why_use_tfa')}</Typography>
                        <Typography variant="body2">
                            {getLabelFromJspVariables('tfa_extra_layer')}
                            {getLabelFromJspVariables('extra_Layer_reduces_chance')}
                            {getLabelFromJspVariables('to_access_need_device')}
                        </Typography>

                        <Typography variant="subtitle2" sx={{ mt: 2 }}>{getLabelFromJspVariables('register_for_tfa')}</Typography>
                        <Typography variant="body2">
                            {getLabelFromJspVariables('call_helpdesk_to_register')}
                            {getLabelFromJspVariables('once_enabled_complete_registration')}
                            {getLabelFromJspVariables('registration_requires_valid_email')}
                            {getLabelFromJspVariables('opt_delivery_options')}
                        </Typography>

                        <Typography variant="subtitle2" sx={{ mt: 2 }}>{getLabelFromJspVariables('label_how_it_works')}</Typography>
                        <Typography variant="body2">
                            {getLabelFromJspVariables('after_registration_periodically')}
                            {getLabelFromJspVariables('tfa_passcode_is')}
                            {getLabelFromJspVariables('new_passcode_when')}
                        </Typography>
                        <Box component="ol" sx={{ pl: 3, mt: 1 }}>
                            <li><Typography variant="body2">{getLabelFromJspVariables('on_initial_login_after')}</Typography></li>
                            <li><Typography variant="body2">{getLabelFromJspVariables('every_30_days')}</Typography></li>
                            <li><Typography variant="body2">{getLabelFromJspVariables('any_login_from_new_ip')}</Typography></li>
                            <li><Typography variant="body2">{getLabelFromJspVariables('after_changes_to_registration')}</Typography></li>
                        </Box>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                            {getLabelFromJspVariables('once_valid_otp')}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </PageContainer>
    );
};

export default PageTfaHelp;
